import React, { forwardRef } from 'react';
import { func, bool, string } from 'prop-types';

import {
  StylePopOut,
  StyledIframe,
  ChatWidgetWrapper,
  StyledPopOutButton
} from './ChatWidget.styled';

const ChatWidget = forwardRef((props, ref) => {
  const { chatURL, isChatOpen, onPopOutClick } = props;

  return (
    <ChatWidgetWrapper isVisible={isChatOpen}>
      <StylePopOut>
        <StyledPopOutButton
          data-dd-action-name="Click on External Chat"
          onClick={onPopOutClick}
        >
          POP OUT
        </StyledPopOutButton>
      </StylePopOut>
      <StyledIframe
        ref={ref}
        src={chatURL}
        frameBorder={0}
        id="chat-widget"
        name="chat-widget"
        title="ChatWidget"
        className="chat-widget"
        sandbox="allow-same-origin allow-scripts"
      />
    </ChatWidgetWrapper>
  );
}, []);

ChatWidget.displayName = 'ChatWidget';

ChatWidget.propTypes = {
  chatURL: string,
  isChatOpen: bool,
  onPopOutClick: func
};

export default ChatWidget;
